<template>
  <v-layout>
    <v-text-field
    prepend-inner-icon="mdi-attachment"
    :label="$t('screener.import_registrants.attach_file')"
    @click="onPickFile"
    @click:append="$emit('onUploadSelectedFileClick', $event)"
    :value="fileName"
    single-line
    persistent-hint
    :hint="hint"
    ></v-text-field>
    <!-- Hidden -->
    <input
    type="file"
    style="display: none"
    ref="fileInput"
    :accept="mimeType"
    @change="onFilePicked"
    />
  </v-layout>
</template>

<script>
import i18n from "@/i18n";

export default {
    name:"ExcelFileUploader",
    data(){
        return{
            fileName:null,
            file:null,
            url:null
        }
    },
    props:{
        mimeType:{
            default:"application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        },
        hint:{
            default:i18n.t('screener.import_registrants.file_hint')
        }
    },
    watch:{
        fileName(value){
            this.$emit('update:fileName', value);
        },
        file(value){
            this.$emit('update:file', value);
        },
        url(value){
           this.$emit('update:url', value);
        }
    },
    methods:{
        onPickFile() {
            this.$refs.fileInput.click();
        },
        onFilePicked(event) {
            const files = event.target.files;
            if (files[0] !== undefined) {
                this.fileName = files[0].name;
                // Check validity of file
                if (this.fileName.lastIndexOf('.') <= 0) {
                    return;
                }
                // If valid, continue
                const fr = new FileReader();
                fr.readAsDataURL(files[0]);
                fr.addEventListener('load', () => {
                    this.url = fr.result;
                    this.file = files[0]; // this is an file that can be sent to server...
                });
            } else {
                this.fileName = '';
                this.file = null;
                this.url = '';
            }
        },
    }

}
</script>

<style>

</style>
